<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.83398 4.83301L8.16732 4.83301L8.16732 9.83301L9.83398 9.83301L9.83398 4.83301ZM9.00065 17.333C13.6007 17.333 17.334 13.5997 17.334 8.99968C17.334 4.39968 13.6007 0.666344 9.00065 0.666344C4.40065 0.666345 0.667319 4.39968 0.66732 8.99968C0.66732 13.5997 4.40065 17.333 9.00065 17.333ZM9.00065 2.33301C12.6757 2.33301 15.6673 5.32468 15.6673 8.99968C15.6673 12.6747 12.6757 15.6663 9.00065 15.6663C5.32565 15.6663 2.33399 12.6747 2.33399 8.99968C2.33399 5.32468 5.32565 2.33301 9.00065 2.33301ZM9.83398 11.4997L8.16732 11.4997L8.16732 13.1663L9.83398 13.1663L9.83398 11.4997Z" :fill="color"/>
  </svg>
</template>

<script>
  export default {
    name: 'icon-warning',
    props: {
      color: {
        type: String,
        default: '#000'
      }
    }
  }
</script>
